import type { IconProps } from "./icon-types";

/**
 * 달력(calendar). 날짜 선택/일정/기간 관련 진입점에서 사용.
 *
 * VS Code의 `VscCalendar` 의도를 c6 아이콘 세트 톤에 맞춰 깔끔한 stroke로 재현 —
 * `react-icons/lu`의 `LuCalendarDays`(Lucide `calendar-days`)를 인라인으로 재현.
 * c6 패키지는 외부 아이콘 라이브러리를 import하지 않으므로(RFC-design-system-split §아이콘).
 * 다른 c6 아이콘과 톤·크기를 맞추기 위해 24 그리드 / stroke 기반 사용.
 */
export const CalendarIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <path d="M8 2v4" />
    <path d="M16 2v4" />
    <rect width="18" height="18" x="3" y="4" rx="2" />
    <path d="M3 10h18" />
    <path d="M8 14h.01" />
    <path d="M12 14h.01" />
    <path d="M16 14h.01" />
    <path d="M8 18h.01" />
    <path d="M12 18h.01" />
    <path d="M16 18h.01" />
  </svg>
);
